import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ViagemTipoDespesaService from "service/viagem/ViagemTipoDespesaService";
import { NumberMatchModeOptions, TextMatchModeOptions, decimalFilterTemplate, filterApplyTemplate } from "utils/filterUtils";

const viagemTipoDespesaService = new ViagemTipoDespesaService();

export default function ViagemTipoDespesaListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Tipos de despesa');

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        valorAlerta: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={viagemTipoDespesaService} urlService="/viagemTipoDespesa" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="viagemTipoDespesa" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="valorAlerta" header="Valor alerta" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => decimalFilterTemplate(options)} />
        </BaseListagem>
    )
}